import { render, staticRenderFns } from "./CancelTermicCourseConfirmationDialog.vue?vue&type=template&id=b7b865fa"
import script from "./CancelTermicCourseConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./CancelTermicCourseConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports